import React from 'react';

import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ICartTotals } from 'components/Payment/CreditCardPayment';
import { IPendingCart } from 'models/cart/IPendingCart';

import './styles.scss';

interface ISubtotalTableProps {
    pendingCart: IPendingCart;
    cartTotals: ICartTotals;
}

/**
 * @param param0 - cartTotals: {
 *      totalItems?: number,
 *      subtotalPrice: number,
 *      tax: number,
 *      totalPrice: number,
 *   }
 * @returns Subtotal, tax and Total table (ReactElement)
 */
export const SubtotalTable = ({pendingCart, cartTotals}: ISubtotalTableProps) => {
    const {t} = useTranslation();

    return (
        <>
            <Table className="bg-white mb-2 SubtotalTable">
                <tbody>
                <tr>
                    <td className="SubtotalTable__table-cell border">
                        <span>{t('create-pending-cart.Subtotal', 'Subtotal')}</span>
                        <span>
                            {pendingCart?.cart?.currency} ${cartTotals.subtotal.toFixed(2)}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td className="SubtotalTable__table-cell border">
                        <span>{t('create-pending-cart.tax', 'Tax')}</span>
                        <span>
                            {pendingCart?.cart?.currency} ${cartTotals.taxRate.toFixed(2)}
                        </span>
                    </td>
                </tr>
                </tbody>
            </Table>
            <Table className="SubtotalTable__total mb-4 bg-white">
                <tbody>
                <tr>
                    <td className="SubtotalTable__table-cell">
                        <span>{t('create-pending-cart.total', 'Total')}</span>
                        <span>
                            {pendingCart?.cart?.currency} ${cartTotals.total.toFixed(2)}
                        </span>
                    </td>
                </tr>
                </tbody>
            </Table>
        </>
    );
};
